export function isValidSyncDate(dateStr: string | null | undefined): boolean {
  if (!dateStr) return false;
  const parsed = new Date(dateStr);
  if (isNaN(parsed.getTime())) return false;
  return parsed.getUTCFullYear() >= 2020;
}
